const immoStickySidebar = () => {
    const element = document.querySelector('.I-js-sticky-overview-box');
    if (!element) return;
    const itemToObserve = document.querySelector('.I-js-element-to-observe');
    const imageWrapper = element.querySelector('.I-js-sticky-image');
    const breakpoint = window.matchMedia('(min-width:992px)');

    const observer = new window.IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            imageWrapper.classList.remove('is-visible');
            return;
        }

        if (entry.boundingClientRect.top < 0) {
            imageWrapper.classList.add('is-visible');
        }
    }, {
        root: null,
        threshold: 0,
    });

    const breakpointChecker = () => {
        if (breakpoint.matches) {
            observer.observe(itemToObserve);
        }
    };

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker();
};

export default immoStickySidebar;
